import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateReachedOut } from "../services/update-reached-out";
import { useToast } from "@/hooks/use-toast";

export function useUpdateReachedOut() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({
      usage_id,
      user_id,
      value,
    }: {
      usage_id: string;
      user_id: string;
      value: boolean;
    }) => updateReachedOut(usage_id, user_id, value),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["professional-change-requests"],
        exact: false,
      });
    },
    onError: () => {
      toast({
        title: "Failed to update reached out status",
        variant: "destructive",
      });
    },
  });
}
